export default class FilterUtil {
    /**
     * 
     * @param filter 
     * @param type 
     * 
     * @returns 
     */
    find(filter, type: string) {
        if (filter) {
            if (filter.$type === type) {
                return filter;
            } else if (filter.$type === "CompoundFilter") {
                const filters = filter.filters;
                for (let f = filters.length; f-- > 0;) {
                    filter = filters[f];

                    if (filter.$type === type) {
                        return filter;
                    }
                }
            }
        }

        return null;
    }
    
    /**
     * 
     * @returns 
     */
    add() {
        const filters = [];
        for(let f = 0; f < arguments.length; f++) {
            const filter = arguments[f];

            if (filter) {
                if (filter.$type === "CompoundFilter") {
                    filters.push.apply(filters, filter.filters);
                } else {
                    filters.push(filter);
                }
            }
        }

        for (let f = filters.length; f-- > 0;) {
            if (filters[f].$type === "NoFilter") {
                filters.splice(f, 1);
            }
        }

        switch (filters.length) {
            case 0:
                return {$type:"NoFilter"};
            case 1:
                return filters[0];
            default:
                return {
                    $type: "CompoundFilter",
                    filters : filters
                };
        }
    }
    
    /**
     * 
     * @param filter 
     * @param type 
     * 
     * @returns 
     */
    remove(filter, type: string) {
        if (filter) {
            if (filter.$type === type) {
                return {$type:"NoFilter"};
            } else if (filter.$type === "CompoundFilter") {
                let filters = filter.filters;

                for (let f = filters.length; f-- > 0;) {
                    const subFilter = filters[f];

                    if (subFilter.$type === type) {
                        if (filters.length === 1) {
                            return {$type:"NoFilter"}; // all filters removed
                        }

                        filters = filters.slice();
                        filters.splice(f, 1);
                        if (filters.length === 1) {
                            return filters[0];
                        }

                        return {
                            $type : "CompoundFilter",
                            filters : filters
                        };
                    }
                }
            }
        }

        return filter;
    }
}
